import { types } from "../actionTypes/premiumActionTypes";

const premiumReducer = (state = [], action) => {
    const { payload } = action
    switch (action.type) {
        case types.GET_PREMIUM_USERS_REQUEST:
            return {
                ...state,
                premiumUserListLoading: true,
            };
        case types.GET_PREMIUM_USERS_SUCCESS:
            return {
                ...state,
                premiumUserListLoading: false,
                premiumUserList: payload.data,
                totalRecords: payload.totalRecords
            };
        case types.GET_PREMIUM_USERS_FAILURE:
            return {
                ...state,
                premiumUserListLoading: false,
            };
        default:
            return state;
    }
};

export default premiumReducer;